<template>
  <div>
  <el-dialog
    v-show="step === 1"
    :visible="true"
    width="500px"
    class="dialog"
    :close-on-click-modal='false'
    :show-close='false'
    top="20vh"
    :append-to-body='true'
    :modal-append-to-body='true'
    ref='consultationStep1'
  >
    <span slot="title" class="dialog-title">
      {{ title }}
    </span>
    <el-form :model="consultationForm" ref="consultationForm" :rules="rules">
      <el-form-item prop="name">
        <el-input
          type="text"
          v-model="consultationForm.name"
          placeholder="姓名"
        >
          <span slot="suffix" class="requiredInput"
            v-if="consultationForm.name === ''">
            (必填)
          </span>
        </el-input>
      </el-form-item>
      <el-form-item prop="company">
        <el-input
          type="text"
          v-model="consultationForm.company"
          placeholder="公司"
        >
          <span slot="suffix" class="requiredInput"
            v-if="consultationForm.company === ''">
            (必填)
          </span>
        </el-input>
      </el-form-item>
      <el-form-item prop="email">
        <el-input
          type="text"
          v-model="consultationForm.email"
          placeholder="Email"
        >
          <span slot="suffix" class="requiredInput"
            v-if="consultationForm.email === ''"
          >
            (必填)
          </span>
        </el-input>
      </el-form-item>
      <el-form-item prop="tel">
        <el-input
          type="text"
          v-model="consultationForm.tel"
          placeholder="聯絡電話"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="dsp" v-if="isDsp">
        <el-input
          type="text"
          v-model="consultationForm.dspName"
          placeholder="欲輸入之DSP"
        >
        <span slot="suffix" class="requiredInput"
            v-if="consultationForm.dspName === ''"
          >
            (必填)
          </span>
        </el-input>
      </el-form-item>
      <el-form-item prop="sales_contact">
        <el-input
          type="text"
          v-model="consultationForm.salesContact"
          placeholder="OneAD業務 / 窗口"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="content">
        <el-input
          type="textarea"
          placeholder="請簡短說明需求。"
          v-model="consultationForm.content"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="submit-btn" type="primary" @click="sendConsultation" :disabled="!isValid">送出</el-button>
      <el-button @click="closeDialog()">取消</el-button>
    </span>
  </el-dialog>
  <el-dialog
      v-show="step === 2"
      :visible="true"
      width="345px"
      height="148px"
      class="step2"
      top="20vh"
      :close-on-click-modal='false'
      :show-close="false"
      center
      :append-to-body='true'
      :modal-append-to-body='true'
  >
    <div>
    需求已送出！ 敬請等候1-2個工作天，<br>
    我們將會有專人與您聯絡。
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
          class="submit-btn"
          type="primary"
          @click="closeDialog"
      >確定</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import reportApi from '@/api/report'

export default {
  name: 'Consultation',
  props: {
    options: {},
    compareData: {},
    hasSendConsultation: {
      type: Boolean,
      default: false
    },
    // 'speed' or 'direct' or 'all'
    type: {
      type: String
    },
    dspName: {},
    qpSimulationReportArr: {},
    // communicate with purposePathWrapper
    bus: {}
  },
  data () {
    const validateRequired = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(' '))
      } else {
        callback()
      }
    }
    const customRule = [{ validator: validateRequired, trigger: 'blur' }]
    return {
      dspTitle: 'OneDATA Request: 輸出受眾資料至DSP平台啟用',
      normalTitle: '立即以此規劃聯繫OneAD團隊',
      consultationForm: {
        name: '',
        company: '',
        email: '',
        tel: '',
        dspName: '',
        salesContact: '',
        content: '請協助以此規劃排Cue，謝謝！'
      },
      rules: {
        name: customRule,
        company: customRule,
        email: customRule,
        dsp: this.isDsp ? customRule : null
      },
      step: 1,
      // for purposePathWrapper, avoid click submit more than once
      isProducingPdf: false
    }
  },
  computed: {
    title () {
      return this.normalTitle
    },
    isValid () {
      return !this.$lodash.isEmpty(this.consultationForm.name) &&
              !this.$lodash.isEmpty(this.consultationForm.company) &&
              !this.$lodash.isEmpty(this.consultationForm.email) &&
              (this.isDsp ? !this.$lodash.isEmpty(this.consultationForm.dsp) : true) &&
              !this.isProducingPdf
    },
    isDsp () {
      return this.dspName !== undefined && this.dspName !== ''
    }
  },
  watch: {
    step: {
      handler () {
        if (this.step === 3) {
          this.$emit('update:hasSendConsultation', true)
          this.$emit('update:showConsultationForm', false)
          this.step = 1
        }
      }
    }
  },
  mounted () {
    // because dialog added twice, and element use the same modal. So the modal will be higher than 1st dialog.
    this.$refs.consultationStep1.$el.style.zIndex += 2
  },
  methods: {
    sendFeedBack () {
      // user.sendFeedback(this.emailTitle, this.emailContent)
      //   .then(res => {
      //     this.emailContent = ''
      //     this.closeDialog()
      //     this.$alert('已送出!')
      //   })
      //   .catch(err => {
      //     this.$alert(`送出失敗 ${err}`)
      //   })
    },
    sendConsultation () {
      const { name, company, email, tel, dspName, salesContact, content } = this.consultationForm

      // purpose path will have bus
      if (this.bus !== undefined) {
        this.isProducingPdf = true
        this.bus.$emit('userFilledForm', this.$lodash.cloneDeep(this.consultationForm))
      } else {
        const reportData = {
          type: this.type,
          name,
          company,
          email,
          tel,
          dsp_name: dspName, // @FIXEME 支援 DSP 平台後要補回來
          sales_contact: salesContact,
          content,
          qp_simulation_report: this.qpSimulationReportArr
        }
        reportApi.simulationConsultation(reportData)
          .then(() => {
            this.step = 2
          })
          .catch(() => {
          // @FIXME: 改成跳出確認視窗
            this.$message.success('送出失敗')
          })
      }
    },
    showThxDialog () {
      this.step = 2
    },
    closeDialog () {
      this.step = 3
    }
  },
  created () {
    if (this.bus) {
      this.bus.$on('pdfProduced', this.showThxDialog)
    }
  },
  beforeDestroy () {
    if (this.bus) {
      this.bus.$off('pdfProduced', this.showThxDialog)
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .el-dialog__header {
    height: 40px;
    width: 100%;
    text-align: center;
    display:  flex;
    align-items: center;
    justify-content:  center;
  }
  .dialog-title {
    width: 214px;
    height: 22px;
    font-family: PingFangTC;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #444444;
  }
  .inputStyle {
    width: 377px;
    height: 83px;
    border-radius: 4px;
    border: solid 1px #c6c6c6;
    background-color: #ffffff;
  }
  .requiredInput {
    text-align: center;
    line-height: 40px;
    width: 38px;
    height: 20px;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: normal;
    color: #d0021b;
  }
  /deep/ .el-textarea__inner {
    height: 120px;
    padding: 0px 15px 0px 10px;
  }
  .submit-btn.is-disabled {
    background-color: #c6c6c6;
    border-color: #c6c6c6;
  }
</style>
